import React, {
  Component
}
from 'react';
import VMasker from "vanilla-masker";
import {
  Input,
  Button,
  Alert
}
from "@maxmilhas/hangar-components-atomic/public";
import BaseCancellationModal from '../base-components/BaseCancellationModal';

export default class BankModalData extends Component {
	constructor() {
		super();
		this.state = {};

		this.handleChange = this.handleChange.bind(this);
		this.changeMask = this.changeMask.bind(this);
		this.ssnHandleChange = this.ssnHandleChange.bind(this);
		this.submit = this.submit.bind(this);
	}

	submit(event) {
    event.preventDefault();
    const data = this.state;
    data.bankAccount = `${data.bankAccount}-${data.bankDigit}`;
    delete data.bankDigit;
		this.props.onSubmit(this.state);
	}

	handleChange(event) {
		this.setState({ [event.target.name]: event.target.value });
	}

	componentDidMount() {
		if (document.getElementById("ssn")) {
			VMasker(document.getElementById("ssn")).maskPattern("999.999.999-99");
		}
	}

	changeMask(masks, max, event) {
		const target = event.target;
		const value = target.value.replace(/\D/g, '');
		VMasker(target).unMask();
		const currentMask = target.value.length > max ? 1 : 0;
		VMasker(target).maskPattern(masks[currentMask]);
		
		target.value = VMasker.toPattern(value, masks[currentMask]);
	}

	ssnHandleChange(event) {
		const ssnMask = ['999.999.999-999', '99.999.999/9999-99'];
		this.changeMask(ssnMask, 11, event);
		this.handleChange(event);
	}
  render = () => {
    return (
      <React.Fragment>
        <BaseCancellationModal open={this.props.open}>
          <div className="modal-header-wrapper">
            <button onClick={() => this.props.closeModal()} className="close-button" alt="Fechar">
              <i className="icon-close" />
            </button>

            <p className="lead">Informe seus dados</p>
            <Alert type="info">
              Os dados bancários devem ser de uma conta do mesmo titular que fez o pagamento. <strong>Importante:</strong> fazemos a transferência apenas para <u>conta corrente</u>. Combinado? ;)
            </Alert>
          </div>
          <div className="tingle-modal-box__content">
            <div className="row">
              <form onSubmit={this.submit}>
                <div className="col-xs-16 col-md-16">
                  <div className="form-group" data-identifier="name">
                    <label htmlFor="name">Nome completo*</label>
                    <Input
                      name="name"
                      autoComplete="off"
                      type="text"
                      className="form-control no-shadow no-bold"
                      id="bankdata_name"
                      onChange={this.handleChange}
                      shadow={0}
                      required
                    />
                  </div>

                  <div className="form-group" data-identifier="name">
                    <label htmlFor="ssn">CPF ou CNPJ*</label>
                    <Input
                      name="ssn"
                      autoComplete="off"
                      id="ssn"
                      type="tel"
                      className="form-control no-shadow no-bold"
                      onChange={this.ssnHandleChange}
                      shadow={0}
                      required
                    />
                  </div>

                  <div className="form-group" data-identifier="name">
                    <label htmlFor="bankName">Banco*</label>
                    <Input
                      name="bankName"
                      autoComplete="off"
                      type="text"
                      className="form-control no-shadow no-bold"
                      id="bank_name"
                      onChange={this.handleChange}
                      shadow={0}
                      required
                    />
                  </div>
                </div>
                <div className="col-xs-16 col-md-5">
                  <div className="form-group" data-identifier="name">
                    <label htmlFor="bankAgency">Agência*</label>
                    <Input
                      name="bankAgency"
                      autoComplete="off"
                      type="text"
                      className="form-control no-shadow no-bold"
                      id="bank_agency"
                      onChange={this.handleChange}
                      shadow={0}
                      required
                    />
                  </div>
                </div>
                <div className="col-xs-16 col-md-8">
                  <div className="form-group" data-identifier="name">
                    <label htmlFor="bankAccount">Conta*</label>
                    <Input
                      name="bankAccount"
                      autoComplete="off"
                      type="text"
                      className="form-control no-shadow no-bold"
                      id="bank_account"
                      onChange={this.handleChange}
                      shadow={0}
                      required
                    />
                  </div>
                </div>
                <div className="col-xs-16 col-md-3">
                  <div className="form-group" data-identifier="name">
                    <label htmlFor="bankAccount">Digito*</label>
                    <Input
                      name="bankDigit"
                      autoComplete="off"
                      type="text"
                      className="form-control no-shadow no-bold"
                      id="bank_digit"
                      onChange={this.handleChange}
                      shadow={0}
                      placeholder="0"
                      required
                    />
                  </div>
                </div>

                <div className="col-xs-16 col-md-16">
                  <div className="form-group" data-identifier="name">
                    <label htmlFor="bankOperation">Operação (Em caso de conta na Caixa)</label>
                    <Input
                      name="bankOperation"
                      autoComplete="off"
                      type="text"
                      className="form-control no-shadow no-bold"
                      id="bank_operation"
                      onChange={this.handleChange}
                      shadow={0}
                    />
                  </div>
                </div>
                <div className="col-xs-16 col-md-16">
                  <Button
                    type="submit"
                    outline={0}
                  >
                    OK
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </BaseCancellationModal>
      </React.Fragment>
    );
  }
}